module.exports = __webpack_public_path__ + "models/total station tripod.c851a24b.gltf";